import type { RouteProps } from 'react-router'
import { Route } from 'react-router-dom'
import { useAppSelector } from 'hooks/reduxHooks'
import { isCorporateEventsHostname } from 'corporateEvents/utils/corporateEventsRoutes'
import { useLocaleStrippedLocation } from './useLocaleStrippedLocation'

export default function LocaleAwareRoute(props: RouteProps) {
  const hostname = useAppSelector(state => state.system.hostname)
  const isCorporateEventsSubdomain = isCorporateEventsHostname(hostname)
  const matchLocation = useLocaleStrippedLocation()

  if (isCorporateEventsSubdomain) {
    return <Route {...props} />
  }

  return <Route {...props} location={matchLocation} />
}
